export default __webpack_public_path__ + "static/media/gcw-hero-desk.53d05b28.mp4";